import React, { useContext, useState } from 'react';
import { Pressable, Text } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import DataState from 'app/src/components/DataState';
import AuthContext from 'app/src/contexts/AuthContext';
import {
  MainContainer,
  ContentContainer,
  PageTitle,
  LinkContainer,
  LinkSpace,
} from 'app/src/elements';
import Modal from 'app/src/elements/Modal';

import { PAYMENT_TERMS, HIDE_PAYMENT_TERM } from './queries';
import SubNav from './SubNav';
import EditPaymentTerm from './edit';

const baseColumns = [
  {
    key: 'name',
    label: 'Name',
    sort: 'asc',
  },
  {
    key: 'days',
    label: 'Days',
  },
];

const PaymentTerms = () => {
  const [showEditModal, setShowEditModal] = useState();
  const { currentUser } = useContext(AuthContext);

  const { data, refetch } = useQuery(PAYMENT_TERMS);

  const [hidePaymentTerm] = useMutation(
    HIDE_PAYMENT_TERM, { onCompleted: refetch }
  );

  if (!data) { return <DataState.Loading /> };

  const onHide = paymentTerm => {
    if (window.confirm(`Hide ${paymentTerm.name}?`)) {
      hidePaymentTerm({ variables: { id: paymentTerm.id }});
    }
  };

  const columns = [
    ...baseColumns,
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: ({ entry }) => (
        <LinkContainer>
          <Pressable onPress={() => setShowEditModal(entry)}>
            <Text>Edit</Text>
          </Pressable>
          <LinkSpace />
          {currentUser.accounting && (
            <Pressable onPress={() => onHide(entry)} >
              <Text>Hide</Text>
            </Pressable>
          )}
        </LinkContainer>
      )
    },
  ];

  return (
    <MainContainer>
      <SubNav refetch={refetch} />

      <ContentContainer>
        <PageTitle>Payment Terms</PageTitle>

        <DataTable.Simple
          data={data.paymentTerms}
          columns={columns}
        />
      </ContentContainer>

      {showEditModal &&
        <Modal
          showModal
          setShowModal={setShowEditModal}
          modalType="Edit Payment Term"
        >
          <EditPaymentTerm
            paymentTerm={showEditModal}
            setShowModal={setShowEditModal}
            refetch={refetch}
          />
        </Modal>
      }
    </MainContainer>
  );
};

export default PaymentTerms;
